// extracted by mini-css-extract-plugin
export default {"partners":"Partners_partners__P3+MG","list":"Partners_list__fUIm0","card":"Partners_card__9w91y"};